import { useState } from "react";
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Btn, Modal } from "@/components/rp";

const SERIES = [["avg_product", "Progetto", "#070707"], ["avg_seller", "Staff", "#9A8B73"], ["avg_team", "Imprese", "#C8BDAB"]];
const fmt = (v) => (v == null ? "—" : `${String(v.toFixed(1)).replace(".", ",")}/5`);

export const TrendChart = ({ trend }) => (
  <div className="rp-card p-5 sm:p-6 mb-4" data-testid="satisfaction-trend">
    <p className="rp-label mb-4">Andamento mese per mese</p>
    {trend.some((t) => t.count) ? (
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={trend} margin={{ top: 5, right: 10, left: -20, bottom: 0 }}>
            <CartesianGrid stroke="#EBEBEB" vertical={false} />
            <XAxis dataKey="label" tick={{ fontSize: 11, fill: "#757575" }} tickLine={false} axisLine={false} />
            <YAxis domain={[1, 5]} ticks={[1, 2, 3, 4, 5]} tick={{ fontSize: 11, fill: "#757575" }} tickLine={false} axisLine={false} />
            <Tooltip formatter={(v, n) => [fmt(v), n]} labelFormatter={(l, p) => `${l} · ${p?.[0]?.payload?.count || 0} verbali`} contentStyle={{ borderRadius: 12, border: "1px solid #EBEBEB", fontSize: 12 }} />
            <Legend iconType="circle" wrapperStyle={{ fontSize: 12 }} />
            {SERIES.map(([k, n, c]) => <Line key={k} type="monotone" dataKey={k} name={n} stroke={c} strokeWidth={2.5} dot={{ r: 3 }} connectNulls />)}
          </LineChart>
        </ResponsiveContainer>
      </div>
    ) : <p className="text-sm text-[#757575]" data-testid="satisfaction-trend-empty">Nessuna valutazione nel periodo: il grafico si riempie con i verbali firmati.</p>}
  </div>
);

export const RecontactDialog = ({ item, onClose, onSaved }) => {
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/soddisfazione/${item.order_id}/recontact`, { note });
      toast.success("Ricontatto registrato");
      onSaved(item.order_id, data);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Modal open onOpenChange={(o) => !o && onClose()} title="Cliente ricontattato" description={`${item.client_name} · ${item.code}${item.client_phone ? ` · ${item.client_phone}` : ""}`} testid="recontact-dialog">
      <textarea rows={4} value={note} onChange={(e) => setNote(e.target.value)} className="rp-field" placeholder="Com'è andata la telefonata? Cosa avete concordato?" data-testid="recontact-note" />
      <div className="flex justify-end gap-2 mt-4">
        <Btn variant="outline" onClick={onClose} data-testid="recontact-cancel">Annulla</Btn>
        <Btn loading={busy} disabled={note.trim().length < 3} onClick={save} data-testid="recontact-save">Salva</Btn>
      </div>
    </Modal>
  );
};
